<template>
  <div class="content">
    <form>
      <refundsuplier-form :datas="dataall"></refundsuplier-form>
      <kontragent :datas="dataall"></kontragent>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
    </form>
  </div>
</template>
<script>
import { RefundsuplierForm, Kontragent, Sklad, Firma, Paytype } from "@/pages";
export default {
  components: {
    RefundsuplierForm,
    Kontragent,
    Sklad,
    Firma,
    Paytype
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
        console.log(this.$store.state.saved);
      }
    }
  },
  // beforeRouteLeave(to, from, next) {
  //   if (this.$store.state.saved < 3) {
  //     this.$store.state.saved = null;
  //     next();
  //   } else {
  //     const answer = window.confirm(
  //       this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
  //     );
  //     if (answer) {
  //       this.$root.$refs.refundsuplier.Savedokument();
  //     } else {
  //       this.$store.state.saved = null;
  //       next();
  //     }
  //   }
  // },
  data() {
    return {
      watch: false,
      update_password: "",
      dataall: {},
      changedisabled:true,
    };
  },
  created:function() {
    this.Data();
    this.$store.state.saved-=1;
    },
  methods: {
    Data() {
      let self = this;
      axios
        .get("api/v1/refund-supplier/id/" + self.$route.params.id, {})
        .then(function(response) {
          self.dataall = response.data;
          self.$store.state.saved=0;
        });
    },
  }
};
</script>
